import { render } from "./TestPanel.vue?vue&type=template&id=d984f972"
import script from "./TestPanel.vue?vue&type=script&lang=js"
export * from "./TestPanel.vue?vue&type=script&lang=js"

import "./TestPanel.vue?vue&type=style&index=0&id=d984f972&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/topdog/labs/TestPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d984f972"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d984f972', __exports__)) {
    console.log('reload')
    api.reload('d984f972', __exports__)
  }
  
  module.hot.accept("./TestPanel.vue?vue&type=template&id=d984f972", () => {
    console.log('re-render')
    api.rerender('d984f972', render)
  })

}


export default __exports__